/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

import React from 'react'
import theme from "./theme";
import AppRoutes from "./Routes";
import { ThemeProvider } from "@mui/material";
import NavAppBar from "./components/NavAppBar";
import { StyledContainer } from "./styles/Container";
import { FileBrowserProvider } from "./contexts/FileBrowserContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import NotificationBar from "./components/NotificationBar";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <NavAppBar />
        <FileBrowserProvider>
          <StyledContainer>
            <AppRoutes />
          </StyledContainer>
        </FileBrowserProvider>
        <NotificationBar />
      </NotificationProvider>
    </ThemeProvider>
  )
}

export default App
